import { Component, forwardRef, Renderer2, ViewChild, Input, OnInit, OnChanges, EventEmitter, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MunicipalityService } from '../../../service/municipality/municipality.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AutocompleteMunicipalityComponent),
  multi: true,
};

@Component({
  selector: 'app-autocomplete-municipality',
  templateUrl: './autocomplete-municipality.component.html',
  styleUrls: ['./autocomplete-municipality.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class AutocompleteMunicipalityComponent implements ControlValueAccessor, OnInit, OnChanges {
    @Input() municipalityId: string;
    @Output() onMyChange = new EventEmitter();
    @Input() disabled: boolean;
    @Input() placeholder: string;

    @ViewChild('input') textarea;

    public municipalitiesOptions: any[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    public sel: any;

    constructor(
        private renderer: Renderer2,
        public municipalityService: MunicipalityService,
        public hasPermissionService: HasPermissionService
    ) {
        this.page = 1;
        this.per_page = 10;
    }

    public ngOnInit() {
        this.query = undefined;
        this.filters = [];
        this.filters.push({key: 'activated-lk', value: '1'});
        if (this.municipalityId) {
            this.filters.push({key: 'id', value: String(this.municipalityId)});
            this.getMunicipalities(this.query, this.filters);
        }
        
    }

    ngOnChanges() {
        //this.ngOnInit();
        // this.query = undefined;
        // this.filters = [];
        
        if (!this.placeholder) 
            this.placeholder = 'municipality';
    }

    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean ) {
        const div = this.textarea.nativeElement;
        if (div) {
            const action = isDisabled ? 'addClass' : 'removeClass';
            this.renderer[action](div, 'disabled');
        }
    }

    public change($event) {
        if(this.sel.id || this.sel ==""){            
            this.onChange(this.sel);
            this.onTouched(this.sel);
            this.onMyChange.emit(this.sel);
        }
    }

    public loadMunicipalitiesLazy(event) {
        //this.getMunicipalities(event.query);
        var str=event.query;
        var res = str.replace(/\s/g, "%");
        this.getMunicipalities(res);
    }

    getMunicipalities(query?: string, filters?: any[]) {
        this.municipalityService.getMunicipality(this.page, this.per_page, this.sort, query, this.filters).toPromise().then(
            response => {
                this.municipalitiesOptions = response.json().data;
                if (this.municipalityId) {
                    this.municipalityId = undefined;
                    this.sel = this.municipalitiesOptions[0];
                    this.filters = [];
                    this.filters.push({key: 'activated-lk', value: '1'});
                }

                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.municipalitiesOptions = [];
                this.municipalitiesOptions.push({id: '', name: 'Error'});
            }
        );
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/municipalities/autocomplete-municipality/autocomplete-municipality.component.ts